
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import NavLink from '../../components/NavLink';

export default function Products() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const projects = [
    {
      client: "Independent Development Trust",
      name: "Extension of Siyamukela School",
      ref: "KNQT 19DOE239",
      category: "Educational Infrastructure",
      description: "School extension project for the Department of Education",
      icon: "ri-government-line",
      contact: "SibusisoB@idt.org.za",
      image: "/projects/zbm-projects (12).jpeg"
    },
    {
      client: "Teichmann Structures (Pty) Ltd",
      name: "New England JV N3 SANRAL - Steel Fixing",
      category: "Road Infrastructure",
      description: "Steel fixing works for N3 highway SANRAL project",
      icon: "ri-roadster-line",
      contact: "kieresh.singh@teichmanngrp.com",
      image: "/projects/zbm-projects (18).jpeg"
    },
    {
      client: "Zingaka Mvelo Projects",
      name: "Maluti Aphofung Local Municipality IBT Housing Project",
      category: "Residential Development",
      description: "IBT housing project for local municipality",
      icon: "ri-home-4-line",
      contact: "info@zingakamvelo.co.za",
      image: "/projects/zbm-projects (25).jpeg"
    },
    {
      client: "Department of Water and Sanitation",
      name: "Mearns Dam Offices House",
      category: "Commercial Building",
      description: "Office construction for water management facility",
      icon: "ri-building-2-line",
      contact: "MtshaliM@dws.gov.za",
      image: "/projects/zbm-projects (7).jpeg"
    },
    {
      client: "Nostra Enviro Projects",
      name: "Construction of Water Storage Tanks (45KL)",
      category: "Water Infrastructure",
      description: "45KL water storage tank construction project",
      icon: "ri-water-flash-line",
      contact: "nostra@lantic.net",
      image: "/projects/zbm-projects (30).jpeg"
    },
    {
      client: "Department of Arts and Culture",
      name: "NPP Library Renovations",
      category: "Renovation Project",
      description: "Library renovation and upgrade project",
      icon: "ri-book-line",
      contact: "ntombelam@kzndac.gov.za",
      image: "/projects/zbm-projects (14).jpeg"
    },
    {
      client: "Department of Health KZN",
      name: "Construction of 21ML Elevated Water Tank",
      category: "Water Infrastructure",
      description: "Large-scale elevated water tank construction",
      icon: "ri-water-flash-line",
      contact: "Sanele.Thembela@kznhealth.gov.za",
      image: "/projects/zbm-projects (35).jpeg"
    }
  ];

  return (
    <div className="min-h-screen bg-white  transition-colors" style={{ fontFamily: 'Prompt, sans-serif' }}>
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-start py-4">
            <div className="flex items-start">
              <Link to="/">
                <Logo size="md" className="hover:scale-105 transition-transform cursor-pointer" />
              </Link>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8 pt-4">
                <NavLink to="/">HOME</NavLink>
                <NavLink to="/about">ABOUT</NavLink>
                <NavLink to="/services">SERVICES</NavLink>
                <NavLink to="/products">PROJECTS</NavLink>
                <NavLink to="/contact">CONTACT</NavLink>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-4 pt-4">
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer drop-shadow-lg">
                Get a Quote
              </Link>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zbm-primary hover:text-zbm-primary-dark cursor-pointer drop-shadow-lg"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 /95 backdrop-blur-sm border-t border-gray-100 ">
              <NavLink to="/" mobile={true}>HOME</NavLink>
              <NavLink to="/about" mobile={true}>ABOUT</NavLink>
              <NavLink to="/services" mobile={true}>SERVICES</NavLink>
              <NavLink to="/products" mobile={true}>PROJECTS</NavLink>
              <NavLink to="/contact" mobile={true}>CONTACT</NavLink>
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer w-full mt-2">
                Get a Quote
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Header Separator Line */}
      <div className="w-full h-px bg-gray-300 mt-32"></div>

      {/* Hero Section */}
      <section className="relative pt-20 pb-20" style={{ backgroundColor: '#F7F7F7' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Our
            <span className="text-zbm-primary block">Projects</span>
          </h1>
          <p className="text-xl text-gray-600  mb-8 max-w-3xl mx-auto leading-relaxed font-normal">
            Explore our portfolio of successfully completed construction projects across South Africa. From government infrastructure to private sector developments, we deliver excellence in every build.
          </p>
          <div className="flex items-center justify-center mb-8">
            <span className="text-2xl mr-3">🏗️</span>
            <p className="text-lg font-semibold text-gray-700 ">Quality. Delivered. On Time.</p>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Completed Projects</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              A selection of our successfully delivered construction projects for government departments, municipalities, and private sector clients.
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-zbm-primary to-zbm-secondary mx-auto rounded-full mt-6"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div key={index} className="bg-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={project.image}
                    alt={project.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4">
                    <div className={`w-12 h-12 ${index % 2 === 0 ? 'bg-zbm-primary' : 'bg-zbm-secondary'} rounded-full flex items-center justify-center shadow-lg`}>
                      <i className={`${project.icon} text-xl text-white`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <div className="mb-3">
                    <span className={`text-xs font-semibold ${index % 2 === 0 ? 'text-zbm-primary' : 'text-zbm-secondary'} uppercase tracking-wide`}>
                      {project.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900  mb-3" style={{ fontFamily: 'Prompt, sans-serif' }}>
                    {project.name}
                  </h3>
                  <p className="text-gray-600  text-sm mb-3 font-normal">
                    <strong>Client:</strong> {project.client}
                  </p>
                  <p className="text-gray-600  text-sm mb-4 font-normal">
                    {project.description}
                  </p>
                  {project.ref && (
                    <p className="text-gray-500  text-xs mb-4 font-normal">
                      <strong>Ref:</strong> {project.ref}
                    </p>
                  )}
                  <div className="flex justify-end mt-4">
                    <Link to="/contact" className={`${index % 2 === 0 ? 'bg-zbm-primary hover:bg-zbm-primary-dark' : 'bg-zbm-secondary hover:bg-zbm-secondary-dark'} text-white px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer`}>
                      Inquire
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose ZBM Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Why Choose ZBM Projects?</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Partner with a construction company committed to excellence, innovation, and sustainable development.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <img 
                src="/projects/zbm-projects (22).jpeg"
                alt="ZBM Projects Construction Excellence"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Commitment to You</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-zbm-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0 mt-1">
                    <i className="ri-shield-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Quality Assurance</h4>
                    <p className="text-gray-600  font-normal">Every project meets the highest standards of quality, safety, and sustainability</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-zbm-secondary rounded-full flex items-center justify-center mr-4 flex-shrink-0 mt-1">
                    <i className="ri-team-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Experienced Team</h4>
                    <p className="text-gray-600  font-normal">ECSA-registered professionals with over 10 years of experience in construction management</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-zbm-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0 mt-1">
                    <i className="ri-time-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>On-Time Delivery</h4>
                    <p className="text-gray-600  font-normal">Proven track record of delivering projects on schedule and within budget</p>
                  </div>
                </div>
              </div>
              <div className="mt-8">
              <Link to="/contact" className="text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer" style={{ background: 'linear-gradient(to right, #1E3A8A, #EA580C)' }}>
                  Start Your Project
              </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Gallery Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Project Gallery</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Explore our portfolio of construction excellence through these project highlights
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[2, 4, 6, 9, 11, 13, 16, 19, 21, 23, 27, 29, 32, 34, 37, 40].map((num) => (
              <div key={num} className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow group">
                <img 
                  src={`/projects/zbm-projects (${num}).jpeg`}
                  alt={`ZBM Project ${num}`}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-white text-sm font-semibold">Project View {num}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners/Clients Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🤝</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Our Valued Partners & Clients</h2>
            </div>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Trusted by leading organizations and government departments across South Africa
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num} className="flex items-center justify-center p-6 bg-white  rounded-lg hover:shadow-lg transition-shadow">
                <img 
                  src={`/partners/zbm-partners (${num}).jpeg`}
                  alt={`Partner ${num}`}
                  className="max-h-20 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                />
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600  font-normal">
              We're proud to work with the Independent Development Trust, Department of Water and Sanitation, 
              Department of Arts and Culture, Department of Health KZN, and many more.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>
                ZBM Projects
              </h3>
              <p className="text-gray-300 mb-6 max-w-md font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Delivering high-quality infrastructure solutions across South Africa.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-zbm-primary hover:bg-zbm-primary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-zbm-secondary hover:bg-zbm-secondary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Services</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Project Management</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Building Construction</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Civil Engineering</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Prefabricated Structures</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Water Infrastructure</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Company</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="hover:text-zbm-primary-light transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/about#team" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Our Team</Link></li>
                <li><Link to="/products" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
          </div>

            <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm font-normal">
                © 2025 ZBM Projects. All Rights Reserved. Reg: 2016/321746/07
              </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
